<template>
  <m-encours-tiers
    :tiersId="fournisseur.id"
    :soldeTiersInfo="soldeTiersInfo"
    :tiersInformation="fournisseur"
    :soldeAtInfiniteDay="soldeAtInfiniteDay"
    :isFromDetailClient="false"
  />
</template>

<script>
import MEncoursTiers from '@/components/tiers/m_EnCoursTiers';

export default {
  props: {
    fournisseur: {
      required: true,
      type: Object,
    },
    soldeTiersInfo: Number,
    soldeAtInfiniteDay: {
      type: Number,
      required: true,
    },
  },
  components: {
    MEncoursTiers,
  },
};
</script>
